import React, { Component } from 'react'
import TestContextLanguage from './TestContextLanguage';
import ContMessageI18N from '../../containers/ContMessageI18N';
import Dico from '../../helpers/Dico';
import TableInformation from '../texts/TableInformation';
import HelperContext from '../../helpers/HelperContext'
import HelperGenerics from '../../helpers/HelperGenerics'
import logoFR from '../../logo/ic_FR.png';
import logoES from '../../logo/ic_ES.png';
import logoIT from '../../logo/ic_IT.png';
import logoDE from '../../logo/ic_DE.png';
import logoAT from '../../logo/ic_AT.png';
import logoCH from '../../logo/ic_CH.png';
import logoGB from '../../logo/ic_GB.png';
import logoBE from '../../logo/ic_BE.png';
import logoNL from '../../logo/ic_NL.png';
import logoPL from '../../logo/ic_PL.png';
import logoPT from '../../logo/ic_PT.png';
import logoLU from '../../logo/ic_LU.png';

const logo = {
	'FR': logoFR, 'ES': logoES, 'IT': logoIT, 'DE': logoDE, 'AT': logoAT,
	'CH': logoCH, 'GB': logoGB, 'BE': logoBE, 'NL': logoNL, 'PL': logoPL, 'PT': logoPT, 'LU': logoLU
};

class TestContext extends Component {

	handleChange(data, name) {
		if (name === undefined) {
			return;
		}
		var context = {
			siteCode: this.props.dataContext.siteCode,
			journeyType: this.props.dataContext.journeyType !== undefined ? this.props.dataContext.journeyType : '',
			renderType: this.props.dataContext.renderType,
			financeJourneyCode: this.props.dataContext.financeJourneyCode,
			isFrom: this.props.dataContext.isFrom,
			colour: this.props.dataContext.colour !== undefined ? this.props.dataContext.colour : '',
			distributionBrand: this.props.dataContext.distributionBrand !== undefined ? this.props.dataContext.distributionBrand : '',
			countryCode: this.props.dataContext.countryCode !== undefined ? this.props.dataContext.countryCode : '',
			languageCode: this.props.dataContext.languageCode,
			userType: this.props.dataContext.userType,
			customer: this.props.dataContext.customer !== undefined ? {
				clientType: this.props.dataContext.customer.clientType,
				youngestDriverAge: this.props.dataContext.customer.youngestDriverAge,
				postCode: this.props.dataContext.customer.postCode
			} : {}
		};
		if (name === 'customerType') {
			context.customer.clientType = data[name];
			this.props.onChangeCustomertype(context);
		} else {
			context[name] = data[name];
		}
		this.handleChangeFillNullIfEmpty(data, name, 'renderType', context);
		this.handleChangeFillNullIfEmpty(data, name, 'userType', context);
		this.handleChangeFillNullIfEmpty(data, name, 'financeJourneyCode', context);
		this.handleChangeFillNullIfEmpty(data, name, 'isFrom', context);
		this.handleChangeFillNullIfEmpty(data, name, 'colour', context);
		if (name === 'countryCode') {
			context['languageCode'] = HelperContext.getDefaultLangage(data[name]);
		}
		if (name === 'siteCode') {
			context.journeyType = HelperContext.adjustJourneyType(this.props.settings.perimeterFilter, context.customer.clientType, [data[name]], context.journeyType);
		}
		if (name === 'countryCode') {
			this.props.onChangeCountryCode(context, this.props.settings.perimeterFilter, this.props.settings.vehDescType);
		} else {
			this.props.onChangeContext(context, this.props.settings.perimeterFilter, this.props.settings.vehDescType);
		}
	}
	handleChangeFillNullIfEmpty(data, name, expectedName, context) {
		if (name === expectedName && data[name].length === 0) {
			context[expectedName] = null;
		}
	}

	handleChangeCheck = name => event => {
		this.handleChange({ [name]: event.target.checked }, name, false);
	}
	handleChangeGeneric = name => event => {
		this.handleChange({ [name]: event.target.value }, name, false);
	};
	handleChangeDistributionBrand = value => {
		if (value != null) {
			this.handleChange({ distributionBrand: value }, 'distributionBrand', false);
		}
	}
	handleChangeCountryCode = value => {
		if (value != null) {
			this.handleChange({ countryCode: value }, 'countryCode', false);
		}
	}

	renderImageCountry = (country) => {
		var label = this.getItemLabel(country, 'countryCode');
		return <React.Fragment><img src={logo[country]} alt={label} /> {label}</React.Fragment>
	}

	renderBrandCode(country, brand) {
		if ('OV' === brand && 'GB' === country) {
			return 'OVX'
		}
		return brand;
	}

	getSimpleLabel(prefix, suffix) {
		return Dico.getMessage(
			this.props.dataContext.countryCode,
			this.props.settings.actualLanguage ? this.props.settings.actualLanguage : this.props.dataContext.languageCode,
			`${prefix}.${suffix}`
		);
	}
	getLabel(fieldname, objectname) {
		const objectnamePart = objectname ? `.${objectname}` : '';
		return this.props.settings.isDevelopperView ? fieldname	
				: this.getMessage(`context${objectnamePart}.${fieldname}`);
	}
	getItemLabel(value, fieldname, objectname, isOption, isPrefix, renderValue, optionStyle) {
		if (renderValue == null) {
			renderValue = value;
		}
		if (renderValue === '') {
			return <option value="" />;
		}
		if (isOption) {
			const objectnamePart = objectname ? `.${objectname}` : '';
			return (
				this.getMessage(`context${objectnamePart}.${fieldname}.${renderValue}`,
					isPrefix ? `${value} - ` : '', value, optionStyle)
			)
		} else {
			const objectnamePart = objectname ? `.${objectname}` : '';
			return (
				<React.Fragment>
					{`${value} - `}
					{this.getMessage(`context${objectnamePart}.${fieldname}.${renderValue}`)}
				</React.Fragment>
			)
		}
	}
	getMessage(i18nKey, prefix, optionValue, optionStyle, isPlainText) {
		return <ContMessageI18N i18n={i18nKey} prefix={prefix} optionValue={optionValue} optionStyle={optionStyle} />// isPlainText={isPlainText}
	}
	render() {
		const countryCode = HelperContext.getAppliedCountry(this.props.dataContext.countryCode, this.props.settings.perimeterFilter);
		const distributionBrand = HelperContext.getAppliedDistributionBrand(this.props.dataContext.distributionBrand, countryCode, this.props.settings.perimeterFilter);
		const colours = ['AC', 'AP', 'AH_AB', 'AR_AL', 'DS', 'FT_FI', 'JE_JE', 'LA_LN', 'OV_OP', 'OV_VA', 'SP', 'MA_MA', 'TOPO', 'BPF'];
		const colourStyles = {
			'': { backgroundColor: '#243782', color: '#ffffff' },
			'DS': { backgroundColor: '#2f2726', color: '#ffffff' },
			'AP': { backgroundColor: '#000000', color: '#ffffff' },
			'AC': { backgroundColor: '#da291c', color: '#ffffff' },
			'SP': { backgroundColor: '#13D0CA', color: '#ffffff' },
			'AH_AB': { backgroundColor: '#111111', color: '#E72020' },
			'AR_AL': { backgroundColor: '#1c1f2a', color: '#f3f3ed' },
			'JE_JE': { backgroundColor: '#ffba01', color: '#000000' },
			'LA_LN': { backgroundColor: '#252b47', color: '#FFFFFF' },
			'OV_OP': { backgroundColor: '#F7FF14', color: '#000000' },
			'OV_VA': { backgroundColor: '#ffffff', color: '#EB001E' },
			'FT_FI': { backgroundColor: '#ffffff', color: '#96172E' },
			'MA_MA': { backgroundColor: '#FFC845', color: '#0D0D0D' },
			'TOPO': { backgroundColor: '#ffffff', color: '#000000' },
			'BPF': { backgroundColor: '#1E2336', color: '#ffffff' }
		}
		const financeJourneyCodes = ['RENTING', 'LLDFLEXFREE', 'LEASINGELEC', 'LEASING_VO', 'PRESELECT'];
		const userTypes = ['CUSTOMER', 'E-SELLER', 'SALESMAN', 'NSC-SC', 'GENIUS', 'NKAM'];
		const clientType = this.props?.dataContext?.customer?.clientType ? this.props.dataContext.customer.clientType : '';
		const siteCode = HelperContext.getAppliedSiteCode(this.props.dataContext.siteCode, this.props.settings.perimeterFilter,
			this.props.settings.vehDescType, countryCode, distributionBrand);
		const journeyTypes = HelperContext.getJourneyTypes(this.props.settings.perimeterFilter, clientType, siteCode);

		const siteCodeSections = HelperContext.getSiteCodeSections(this.props.settings.perimeterFilter, this.props.settings.vehDescType,
			 countryCode, distributionBrand);
		const clientTypes = ['P', 'E', 'EMPL', 'COLL'];
		const renderTypes = ['ONLINE', 'STAMP', 'DEALERTOOL'];
		const isFroms = ['True', 'False'];
		const renderType = HelperGenerics.getBlankOrValue(this.props.dataContext.renderType);
		const financeJourneyCode = HelperGenerics.getBlankOrValue(this.props.dataContext.financeJourneyCode);
		const userType = HelperGenerics.getNullOrValue(this.props.dataContext.userType);
		const isFrom = HelperGenerics.getBlankOrValue(this.props.dataContext.isFrom);
		const colour = HelperGenerics.getBlankOrValue(this.props.dataContext.colour);
		const youngestDriverAge =  this.props?.dataContext?.customer?.youngestDriverAge ? this.props.dataContext.customer.youngestDriverAge : '';
		const postCode = this.props?.dataContext?.customer?.postCode ? this.props.dataContext.customer.postCode : '';
		return (
			<div className="row shadow p-2">
				{this.renderDropdownCountries()}
				<TestContextLanguage
					value={this.props.dataContext.languageCode}
					onChange={(data) => this.handleChange(data, 'languageCode')}
					theme={this.theme}
					country={countryCode}
					settings={this.props.settings}
				/>
				{this.renderDropdownDistributionBrand()}
				<div className="col-auto">
					<label htmlFor="testScreen-customerType" className="form-label">{this.getLabel('clientType')}</label>
					<select className="form-select" id="testScreen-customerType"
						onChange={this.handleChangeGeneric('customerType')} value={clientType}>
						{(clientType == null || clientType.length === 0) && <option value="" />}
						{clientTypes.map((clientType, index) => (
							<React.Fragment key={index}>{this.getItemLabel(clientType, 'clientType', null, true, true)}</React.Fragment>
						))}
					</select>
				</div>
				<div className="col-auto">
					<label htmlFor="testScreen-siteCode" className="form-label">{this.getLabel('siteCode')}</label>
					<select className="form-select" id="testScreen-siteCode"
						onChange={this.handleChangeGeneric('siteCode')} value={siteCode}>
						{siteCode == null && <option value="" />}
						{Object.keys(siteCodeSections).map((siteCodeSectionKey, index0) => (
							<optgroup label={this.getSimpleLabel('context.siteCodeSection', siteCodeSectionKey)} key={index0}>
								{siteCodeSections[siteCodeSectionKey].map((siteCode, index) => (
									<React.Fragment key={index}>{this.getItemLabel(siteCode, 'siteCode', null, true, true)}</React.Fragment>
								))}
							</optgroup>
						))}
					</select>
				</div>
				<div className="col-auto">
					<label htmlFor="testScreen-journeyType" className="form-label">{this.getLabel('journeyType')}</label>
					<select className="form-select" id="testScreen-journeyType"
						onChange={this.handleChangeGeneric('journeyType')} value={this.props.dataContext.journeyType}>
						{journeyTypes.map((journeyType, index) => (
							<React.Fragment key={index}>{this.getItemLabel(journeyType, 'journeyType', null, true, true)}</React.Fragment>
						))}
					</select>
				</div>
				<div className="col-auto">
					<label htmlFor="testScreen-renderType" className="form-label">{this.getLabel('renderType')}</label>
					<select className="form-select" id="testScreen-renderType"
						onChange={this.handleChangeGeneric('renderType')} value={renderType}>
						<option value="" />
						{renderTypes.map((renderType, index) => (
							<React.Fragment key={index}>{this.getItemLabel(renderType, 'renderType', null, true, true)}</React.Fragment>
						))}
					</select>
				</div>
				<div className="col-auto">
					<label htmlFor="testScreen-isFrom" className="form-label">{this.getLabel('isFrom')}</label>
					<select className="form-select" id="testScreen-isFrom"
						onChange={this.handleChangeGeneric('isFrom')} value={isFrom}>
						<option value="" />
						{isFroms.map((isFrom, index) => (
							<React.Fragment key={index}>{this.getMessage(`generics.${isFrom}`, null, isFrom)}</React.Fragment>
						))}
					</select>
				</div>
				<div className="col-auto">
					<label htmlFor="testScreen-userType" className="form-label">{this.getLabel('userType')}</label>
					<select className="form-select" id="testScreen-userType"
						onChange={this.handleChangeGeneric('userType')} value={userType}>
							<option value="" />
						{userTypes.map((userType, index) => (
							<option key={index} value={userType}>
								{userType}
							</option>
						))}
					</select>
				</div>
				<div className="col-auto">
					<label htmlFor="testScreen-financeJourneyCode" className="form-label">{this.getLabel('financeJourneyCode')}</label>
					<select className="form-select" id="testScreen-financeJourneyCode"
						onChange={this.handleChangeGeneric('financeJourneyCode')} value={financeJourneyCode}>
						<option value="" />
						{financeJourneyCodes.map((financeJourneyCode, index) => (
							<React.Fragment key={index}>{this.getItemLabel(financeJourneyCode, 'financeJourneyCode', null, true, true)}</React.Fragment>
						))}
					</select>
				</div>
				<div className="col-auto">
					<label htmlFor="testScreen-colour" className="form-label">{this.getLabel('colour')}</label>
					<select className="form-select" id="testScreen-colour"
						onChange={this.handleChangeGeneric('colour')} value={colour} style={colourStyles[colour]}>
						{this.getMessage('context.colour.SFS', null, '', colourStyles[''])}
						{colours.map((colour, index) => (
							<React.Fragment key={index}>{this.getItemLabel(colour, 'colour', null, true, true, null, colourStyles[colour])}</React.Fragment>
						))}
					</select>
				</div>
				{(youngestDriverAge || postCode) &&
					<div className="col-auto"><TableInformation
						developperView={this.props.settings.isDevelopperView}
						values={this.props.dataContext.customer}
						i18nPrefix='calculatorPage.criteria.customer'
						fieldname='customer'

					/></div>
				}
			</div>
		)
	}

	renderDropdownCountries() {
		const countryCode = HelperContext.getAppliedCountry(this.props.dataContext.countryCode, this.props.settings.perimeterFilter);
		const countries = HelperContext.getCountries(this.props.settings.perimeterFilter);
		return (
			<div className="dropdown col-auto">
				<label>{this.getLabel('countryCode')}</label>
				<button className="btn btn-light dropdown-toggle form-select" type="button" id="dropdownMenuButtonCountry" data-bs-toggle="dropdown" aria-expanded="false">
					<img src={logo[countryCode]} alt={this.getItemLabel(countryCode, 'countryCode')} />
					{this.getItemLabel(countryCode, 'countryCode')}
				</button>
				<ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonCountry" style={{ maxHeight: '400px', overflowY: 'scroll' }}>
					{countries.map((country, index) => (
						<li key={index}>
							<button className="dropdown-item p-2" style={{ width: '250px' }} type="button" onClick={() => { this.handleChangeCountryCode(country) }}>
								<img src={logo[country]} alt={this.getItemLabel(country, 'countryCode')} />
								{this.getItemLabel(country, 'countryCode')}
							</button>
						</li>
					))}
				</ul>
			</div>
		)
	}

	renderDropdownDistributionBrand() {
		const countryCode = HelperContext.getAppliedCountry(this.props.dataContext.countryCode, this.props.settings.perimeterFilter);
		const distributionBrand = HelperContext.getAppliedDistributionBrand(this.props.dataContext.distributionBrand, countryCode,
			this.props.settings.perimeterFilter);
		const brandSections = HelperContext.getDistributionBrandSections(this.props.settings.perimeterFilter, countryCode);
		return (
			<div className="dropdown col-auto">
				<label>{this.getLabel('distributionBrand')}</label>
				<button className="btn btn-light dropdown-toggle form-select" type="button"
					id="dropdownMenuButtonDistributionBrand" data-bs-toggle="dropdown" data-bs-auto-close="true"
					aria-expanded="false">
					{this.getItemLabel(distributionBrand, 'distributionBrand', null, false, false, this.renderBrandCode(countryCode, distributionBrand))}
				</button>
				<ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonDistributionBrand" style={{ maxHeight: '500px', overflowY: 'scroll' }}>
					{Object.keys(brandSections).map((brandSectionKey, index0) => (
						<React.Fragment key={index0}>
							<li><h6 className="dropdown-header">{brandSectionKey}</h6></li>
							{
								brandSections[brandSectionKey].map((brand, index) => {
									return (
										<li key={index}>
											<button className="dropdown-item p-2" style={{ width: '250px' }} type="button" onClick={() => { this.handleChangeDistributionBrand(brand) }}>
												<span style={{ position: 'relative'}}>{this.getItemLabel(brand, 'distributionBrand', null, true, true, this.renderBrandCode(countryCode, brand))}</span>
											</button>
										</li>
									)
								})
							}
							<li><hr className="dropdown-divider" /></li>
						</React.Fragment>
					))}
				</ul>
			</div>
		)
	}
}

export default (TestContext);
